<template>
    <div id="app">
        <vue-topprogress ref="topProgress" color="#EA502D" :minimum="70" :speed="200" id="topProgress"></vue-topprogress>
        <div class="wrapper">
            <div class="wrapper-in">
                <AppHeader ></AppHeader>
                <mobileSidebar v-if="isMobileChecker"></mobileSidebar>
                <main class="content" id="content-layout">
                    <transition
                        name="fade"
                        mode="out-in"
                    >
                        <router-view v-cloak/>
                    </transition>
                </main>
                <AppFooter></AppFooter>
                <transition
                    name="fade"
                    mode="out-in"
                >
                    <div class="body-overlay" id="body-overlay" @click="closeMobileMenu(!openSendwich)" v-cloak v-if="openSendwich || openFormConsult" :class="{'openFormConsult': openFormConsult}"></div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import AppHeader from '@/components/header/header.vue'
    import AppFooter from '@/components/footer/footer.vue'
    import mobileSidebar from '@/components/mobile-sidebar/mobile-sidebar.vue'
    import {mapGetters} from 'vuex'
    export default {
        components: {
            AppHeader,
            AppFooter,
            mobileSidebar,
        },
        data () {
            return {
                iSmobile: false,
                title: '',
            }
        },
        computed: mapGetters({
            openSendwich: 'loadOpenSendwich',
            openFormConsult: 'loadOpenFormConsult',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            initSupportPage() {
                this.$router.push({name: 'support'});
            },
            closeMobileMenu(data) {
                this.$store.commit('Open_Sendwich', false);
                this.$store.commit('Open_form_Consult', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
            },
            // MOBILE CHECKER
            // MOBILE CHECKER
            isMobileCheck() {
                if (window.innerWidth < 800) {
                    this.$store.commit('setMobileCheckerState', true);
                    // this.$store.commit('setOffsetResponse', -60);
                }
            },
            handleResize() {
                if (window.innerWidth < 800) {
                    this.$store.commit('setMobileCheckerState', true);
                } else {
                    this.$store.commit('setMobileCheckerState', false);
                }
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
        },
        beforeCreate() {
            if (localStorage.getItem('language') === null) {
                localStorage.setItem('language', '');
            }
            this.$store.dispatch('getPageSetUp');
            this.$store.dispatch('getProjectsPage');
        },
        created () {
        },
        mounted () {
            this.$refs.topProgress.start();
            this.isMobileCheck();
            this.checkResize();
        }
    }
</script>